// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sy-select-tree[data-v-1dce1332]{position:relative;z-index:20}.sy-select-tree .tree-wrapper[data-v-1dce1332]{position:absolute;left:0;right:1px;top:34px;border:1px solid #ccc;background:#fff;padding-bottom:8px}", ""]);
// Exports
module.exports = exports;
